import { render, staticRenderFns } from "./BaseFichaFuncionario.vue?vue&type=template&id=440e1e88"
import script from "./BaseFichaFuncionario.vue?vue&type=script&lang=js"
export * from "./BaseFichaFuncionario.vue?vue&type=script&lang=js"
import style0 from "./BaseFichaFuncionario.vue?vue&type=style&index=0&id=440e1e88&prod&lang=css"
import style1 from "./BaseFichaFuncionario.vue?vue&type=style&index=1&id=440e1e88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports